import type { DeclaredInterface } from '../envelope/baseline.js'
import type { InterfaceDiff } from '../reconcile/types.js'
import type { InferredInterface } from './index.js'

export function diffInterfaces(
  declared: DeclaredInterface[],
  inferred: InferredInterface[],
): InterfaceDiff[] {
  const inferredByModule = new Map<string, InferredInterface>()
  for (const i of inferred) {
    inferredByModule.set(i.module, i)
  }

  const diffs: InterfaceDiff[] = []
  const seenModules = new Set<string>()

  for (const declared_i of declared) {
    seenModules.add(declared_i.module)
    const inferred_i = inferredByModule.get(declared_i.module)
    const declaredExports = new Set(declared_i.exports)
    const inferredExports = new Set(inferred_i?.exports ?? [])

    const addedExports = [...inferredExports].filter(e => !declaredExports.has(e))
    const removedExports = [...declaredExports].filter(e => !inferredExports.has(e))

    if (addedExports.length > 0 || removedExports.length > 0) {
      diffs.push({
        module: declared_i.module,
        addedExports,
        removedExports,
        changedSignatures: [],
      })
    }
  }

  for (const inferred_i of inferred) {
    if (seenModules.has(inferred_i.module)) continue
    if (inferred_i.exports.length > 0) {
      diffs.push({
        module: inferred_i.module,
        addedExports: [...inferred_i.exports],
        removedExports: [],
        changedSignatures: [],
      })
    }
  }

  return diffs
}
